module.exports = __webpack_public_path__ + "img/wx.aaf27d02.png";